module.exports = __webpack_public_path__ + "assets/img/ic-ticket.0d6ff7c2.svg";